export const OPERATOR_IMAGE_URL = "Storage/Images/Operator";
export const ACCOUNT_FILE_URL = "Storage/Files/Account";
export const ACCOUNT_IMAGE_PATH = "Storage/Images/Account";
//export const BANNER_IMAGE_URL              = "Public/Images/Banner";
